import React from 'react'
import {  Row, Col } from "react-bootstrap"
import { ScrollablePane, ScrollbarVisibility } from '@fluentui/react';
import BusinessElementCard from '../BusinessElementCard';
import PropTypes from 'prop-types';

import '../../../../../../styles/css/RelatedConcept.css'


function GAPElementTypeBox(props) {
    //Helpers

    //Parametros de entrada.
    const { 
        inputParam_SelectedElementId = null,
        inputParam_ElementList = null,
        inputParam_GAPId = null,
        inputParam_EditMode = null,
        inputParam_SetterSelectedElementId = null,
        inputParam_SetterStructurerevisionDataserieFullList = null,
        inputParam_ClickEnabled = true,
    } = props;

    //Parametros de componente.

    //Funciones de componente.

    //Eventos de componente.
    const onSelectElement = (elementId) => {
        inputParam_SetterSelectedElementId && inputParam_SetterSelectedElementId(elementId)
        inputParam_SetterStructurerevisionDataserieFullList && inputParam_SetterStructurerevisionDataserieFullList(null)
    }
    
    //Toolbar (Debe estar previo al render para no generar problemas de que no existan los eventos previo a ser instanciados)

    //Render de componente.
    return (
        <ScrollablePane
            style={{maxHeight: "100%", height: "100%"}}
            styles={{
                root: { position: "relative" },
                contentContainer:{overflowX: "hidden"}
            }}
            scrollbarVisibility={ScrollbarVisibility.auto}
            scrollContainerFocus={true}
        >
            <Row className='h-1001'>
                {
                    inputParam_ElementList && inputParam_SelectedElementId && inputParam_ElementList.map((element, index) => 
                        <Col key={ index } onClick={ inputParam_ClickEnabled ? () => onSelectElement(element.elementId) : null}>
                            <div>
                            <BusinessElementCard
                                inputParam_EditMode={inputParam_EditMode}
                                inputParam_SelectedElementId={inputParam_SelectedElementId}
                                inputParam_ElementItem={ element }
                                inputParam_GAPId={inputParam_GAPId}
                                inputParam_CompactMode={true}
                            />
                            </div>
                        </Col>
                    )
                }
            </Row>
        </ScrollablePane>
    );
}

///Proptypes
GAPElementTypeBox.propTypes = {
    inputParam_GAPId: PropTypes.number,
    inputParam_SelectedElementId: PropTypes.number,
    inputParam_ElementList: PropTypes.array.isRequired,
    inputParam_SetterSelectedElementId: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_SetterGapRevisionDataserieList: PropTypes.func,
    inputParam_ClickEnabled: PropTypes.bool,
};

export default GAPElementTypeBox;